import React,{Component} from 'react';
import './MapsNewOrder.css';
import searchbule from '../../../image/searchbule.svg'

class MapsNewOrder extends Component{
    constructor(props) {
        super(props);
        this.state = {
            venues: []


        };    this.renderMap()

      }
      
  componentDidMount() {

    
  }

  renderMap = () => {
    loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBY3D5O9OFeDgG1-RF9OJy0CNAzFYfix4s&libraries=places&callback=initMap")
    window.initMap = this.initMap
  }
 
   

  initMap = () => {

    // Create A Map
    var map = new window.google.maps.Map(document.getElementById('map'), {
        center: {lat: 30.020, lng: 31.457},
      zoom: 10
    })

    // Create An InfoWindow
    var infowindow = new window.google.maps.InfoWindow()
    var geocoder = new window.google.maps.Geocoder();

    // // Display Dynamic Markers ,, add marker in map
    
    // this.state.venues.map(myVenue => {
    //   var contentString = `${myVenue.venue.name}`
    //   // Create A Marker
    //   var marker = new window.google.maps.Marker({
    //     position: {lat: 30.050 , lng:33.233 },
    //     map: map,
    //     title: myVenue.venue.name
    //   })
    //   // Click on A Marker!
    //   marker.addListener('click', function() {
    //     // Change the content
    //     infowindow.setContent(contentString)
    //     console.log()
    //     // Open An InfoWindow
    //     infowindow.open(map, marker)
    //   })

    // })

    
    var card = document.getElementById('pac-card');
    var input = document.getElementById('pac-input');
   
    map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(card);
    var autocomplete = new window.google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);

    // Set the data fields to return when the user selects a place.
    autocomplete.setComponentRestrictions(
        {'country': ['eg'],});

    autocomplete.setFields(
        ['place_id', 'geometry', 'icon', 'name','formatted_address']);

    var infowindow = new window.google.maps.InfoWindow();
    if(this.props.state.address_name&&this.props.state.coordinates){
var address=this.props.state.address_name
    var marker = new window.google.maps.Marker({
      map: map,
      position: {lat: this.props.state.coordinates[0], lng:this.props.state.coordinates[1] },
      draggable:true,
                       

    });
    window.google.maps.event.addListener(marker, 'click', function() {
      infowindow.setContent(address );
      infowindow.open(map, this);
    });
  
    window.google.maps.event.addListener(marker, 'dragend', ()=> {
      const myLatlng = new window.google.maps.LatLng(marker.getPosition().lat() ,marker.getPosition().lng());
        geocoder.geocode({'latLng': myLatlng }, (results, status)=> {
            if (status == window.google.maps.GeocoderStatus.OK) {
            if (results[0]) {
            const myLatlngformattedaddress =(results[0].formatted_address);
            const x2 =(marker.getPosition().lat());
            const x3 = (marker.getPosition().lng());
            const coordinates = [x2,x3]
            // this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
            if(myLatlngformattedaddress.toLowerCase().search("cairo")!==-1||myLatlngformattedaddress.toLowerCase().search("القاهرة")!==-1||myLatlngformattedaddress.toLowerCase().search("giza")!==-1||myLatlngformattedaddress.toLowerCase().search("الجيوة")!==-1){
              this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
              infowindow.setContent(myLatlngformattedaddress);
              // console.log(myLatlngformattedaddress)
              // console.log(this.props.state)
              infowindow.open(map, marker);
            }else{
              this.props.setStatecoordinatesaddress_alias([],"No Deliver out Cairo")

              infowindow.setContent("No Deliver out Cairo");

            }
           
            }
            }
            });
        })
      }else{
        var marker = new window.google.maps.Marker({
          map: map,
          anchorPoint: new window.google.maps.Point(0, -29),
          draggable:true
        });
      }

    autocomplete.addListener('place_changed', () => {
        infowindow.close();
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name + "'");
          return;
        }
     // If the place has a geometry, then present it on a map.
     if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);        
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);  // Why 17? Because it looks good.
      }
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);


                 const myLatlng = new window.google.maps.LatLng(marker.getPosition().lat() ,marker.getPosition().lng());

                geocoder.geocode({'latLng': myLatlng }, (results, status) =>{
                    if (status == window.google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                        const myLatlngformattedaddress =(results[0].formatted_address);
                        const x2 =(marker.getPosition().lat());
                        const x3 = (marker.getPosition().lng());
                        const coordinates = [x2,x3]
                        // this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
                        

                         if(myLatlngformattedaddress.toLowerCase().search("cairo")!==-1||myLatlngformattedaddress.toLowerCase().search("القاهرة")!==-1||myLatlngformattedaddress.toLowerCase().search("giza")!==-1||myLatlngformattedaddress.toLowerCase().search("الجيزة")!==-1){
                          this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
                          infowindow.setContent(myLatlngformattedaddress);
                          infowindow.open(map, marker);
                          }else{
                            this.props.setStatecoordinatesaddress_alias([],"No Deliver out Cairo")

                            infowindow.setContent("No Deliver out Cairo");

                          }
                    // console.log(myLatlng_formatted_address)
                    // console.log(this.props.state)
                    // console.log(x3)
                    }
                    }
                });
                window.google.maps.event.addListener(marker, 'dragend', ()=> {
                  const myLatlng = new window.google.maps.LatLng(marker.getPosition().lat() ,marker.getPosition().lng());
                    geocoder.geocode({'latLng': myLatlng }, (results, status)=> {
                        if (status == window.google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                        const myLatlngformattedaddress =(results[0].formatted_address);
                        const x2 =(marker.getPosition().lat());
                        const x3 = (marker.getPosition().lng());
                        const coordinates = [x2,x3]
                        // this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
                        if(myLatlngformattedaddress.toLowerCase().search("cairo")!==-1||myLatlngformattedaddress.toLowerCase().search("القاهرة")!==-1||myLatlngformattedaddress.toLowerCase().search("giza")!==-1||myLatlngformattedaddress.toLowerCase().search("الجيزة")!==-1){
                          this.props.setStatecoordinatesaddress_alias(coordinates,myLatlngformattedaddress)
                          infowindow.setContent(myLatlngformattedaddress);
                          // console.log(myLatlngformattedaddress)
                          // console.log(this.props.state)
                          infowindow.open(map, marker);
                        }else{
                          this.props.setStatecoordinatesaddress_alias([],"No Deliver out Cairo")
                          infowindow.setContent("No Deliver out Cairo");
                        }
                        }
                        }
                        });
                    })
      // show content in click marker
    });

    // Sets a listener on a radio button to change the filter type on Places
    // Autocomplete.
    
















if(this.props.state.usemaps===true){

    // Create A Map
    var map2 = new window.google.maps.Map(document.getElementById('map2'), {
      center: {lat: 30.020, lng: 31.457},
      zoom: 10
  })

  // Create An InfoWindow
  var infowindow2 = new window.google.maps.InfoWindow()
  var geocoder2 = new window.google.maps.Geocoder();

  // // Display Dynamic Markers ,, add marker in map
  
  // this.state.venues.map(myVenue => {
  //   var contentString = `${myVenue.venue.name}`
  //   // Create A Marker
  //   var marker = new window.google.maps.Marker({
  //     position: {lat: 30.050 , lng:33.233 },
  //     map: map,
  //     title: myVenue.venue.name
  //   })
  //   // Click on A Marker!
  //   marker.addListener('click', function() {
  //     // Change the content
  //     infowindow2.setContent(contentString)
  //     console.log()
  //     // Open An InfoWindow
  //     infowindow2.open(map, marker)
  //   })

  // })

  
  var card2 = document.getElementById('pac-card2');
  var input2 = document.getElementById('pac-input2');
 
  map2.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(card2);

  var autocomplete2 = new window.google.maps.places.Autocomplete(input2);
  autocomplete2.bindTo('bounds', map2);

  // Set the data fields to return when the user selects a place2.
  autocomplete2.setComponentRestrictions(
      {'country': ['eg']});

  autocomplete2.setFields(
      ['place_id', 'geometry', 'icon', 'name','formatted_address']);

  var infowindow2 = new window.google.maps.InfoWindow();
  if(this.props.state.pickupaddress_name&&this.props.state.pickupcoordinates){
    var address2=this.props.state.pickupaddress_name
        var marker2 = new window.google.maps.Marker({
          map: map2,
          position: {lat: this.props.state.pickupcoordinates[0], lng:this.props.state.pickupcoordinates[1] },
          draggable:true,
                          
        });
        window.google.maps.event.addListener(marker2, 'click', function() {
          infowindow2.setContent(address2 );
          infowindow2.open(map2, this);
        });
      
        window.google.maps.event.addListener(marker2, 'dragend', ()=> {
          const myLatlng2 = new window.google.maps.LatLng(marker2.getPosition().lat() ,marker2.getPosition().lng());
            geocoder.geocode({'latLng': myLatlng2 }, (results, status)=> {
                if (status == window.google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                const myLatlng_formatted_address2 =(results[0].formatted_address);
                const x2 =(marker2.getPosition().lat());
                const x3 = (marker2.getPosition().lng());
                const coordinates2 = [x2,x3]
                
                if(myLatlng_formatted_address2.toLowerCase().search("cairo")!==-1||myLatlng_formatted_address2.toLowerCase().search("القاهرة")!==-1||myLatlng_formatted_address2.toLowerCase().search("giza")!==-1||myLatlng_formatted_address2.toLowerCase().search("الجيوة")!==-1){
                  this.props.setStatecoordinatesaddress_aliaspickup(coordinates2,myLatlng_formatted_address2)
                  infowindow2.setContent(myLatlng_formatted_address2);
                  infowindow2.open(map2, marker2);
                }else{
                  this.props.setStatecoordinatesaddress_alias([],"No pick up out Cairo")
                  infowindow.setContent("No Deliver out Cairo");
                }
                // console.log(myLatlngformattedaddress)
                // console.log(this.props.state)
                }
                }
                });
            })
          }else{
            var marker2 = new window.google.maps.Marker({
              map: map2,
              anchorPoint: new window.google.maps.Point(0, -29),
              draggable:true
            });
          }
  autocomplete2.addListener('place_changed', ()=> {
      infowindow2.close();
      marker2.setVisible(false);
      var place2 = autocomplete2.getPlace();
      if (!place2.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place2.name + "'");
        return;
      }
   // If the place has a geometry, then present it on a map.
   if (place2.geometry.viewport) {
    map2.fitBounds(place2.geometry.viewport);        
    } else {
      map2.setCenter(place2.geometry.location);
      map2.setZoom(17);  // Why 17? Because it looks good.
    }
    marker2.setPosition(place2.geometry.location);
    marker2.setVisible(true);


               const myLatlng2 = new window.google.maps.LatLng(marker2.getPosition().lat() ,marker2.getPosition().lng());

              geocoder2.geocode({'latLng': myLatlng2 }, (results, status)=> {
                  if (status == window.google.maps.GeocoderStatus.OK) {
                  if (results[0]) {
                      const myLatlng_formatted_address2 =(results[0].formatted_address);
                      const l2 =(marker2.getPosition().lat());
                      const l3 = (marker2.getPosition().lng());
                      const coordinates2 = [l2,l3]

                      if(myLatlng_formatted_address2.toLowerCase().search("cairo")!==-1||myLatlng_formatted_address2.toLowerCase().search("القاهرة")!==-1||myLatlng_formatted_address2.toLowerCase().search("giza")!==-1||myLatlng_formatted_address2.toLowerCase().search("الجيزة")!==-1){
                        this.props.setStatecoordinatesaddress_aliaspickup(coordinates2,myLatlng_formatted_address2)
                        infowindow2.setContent(myLatlng_formatted_address2);
                        infowindow2.open(map2, marker2);
                      }else{
                        this.props.setStatecoordinatesaddress_aliaspickup([],"No pick up out Cairo")
                        infowindow.setContent("No Deliver out Cairo");
                      }
                  }
                  }
              });
        window.google.maps.event.addListener(marker2, 'dragend', ()=> {
          const myLatlng2 = new window.google.maps.LatLng(marker2.getPosition().lat() ,marker2.getPosition().lng());
            geocoder2.geocode({'latLng': myLatlng2 }, (results, status)=> {
                if (status == window.google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                const myLatlng_formatted_address2 =(results[0].formatted_address);
                const l2 =(marker2.getPosition().lat());
                const l3 = (marker2.getPosition().lng());
                const coordinates2 = [l3,l2]

                if(myLatlng_formatted_address2.toLowerCase().search("cairo")!==-1||myLatlng_formatted_address2.toLowerCase().search("القاهرة")!==-1||myLatlng_formatted_address2.toLowerCase().search("giza")!==-1||myLatlng_formatted_address2.toLowerCase().search("الجيزة")!==-1){
                  this.props.setStatecoordinatesaddress_aliaspickup(coordinates2,myLatlng_formatted_address2)
                  infowindow2.setContent(myLatlng_formatted_address2);
                  infowindow2.open(map2, marker2);
                }else{
                  this.props.setStatecoordinatesaddress_aliaspickup([],"No pick up out Cairo")
                  infowindow.setContent("No Deliver out Cairo");
                }
                }
                }
                });
            })
    // show content in click marker
    // infowindow2.open(map2, marker2);
  });
  }
}
    render(){
        return(
        <>
       
        </>
  
        )
    }
}
function loadScript(url) {
  var index  = window.document.getElementsByTagName("script")[0]
  var script = window.document.createElement("script")
  script.src = url
  script.async = true
  script.defer = true
  index.parentNode.insertBefore(script, index)
}
export default MapsNewOrder;